import React from 'react';
import { CheckIcon } from 'lucide-react';
import { takeaways } from '../data/landing';
export function TakeawaysSection() {
  return <section id="que-te-llevas" className="bg-cream-deep py-14 sm:py-20" data-id="element-108" data-mp="25movbtknb4y9">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-109" data-mp="2ak6w2woiedv6">
        <div className="rounded-[2rem] bg-white p-7 shadow-card sm:p-10" data-id="element-110" data-mp="2anmcc2tx5sy6">
          <h2 className="max-w-xl font-display text-2xl font-semibold leading-tight tracking-tight text-petrol sm:text-[2rem]" data-id="element-111" data-mp="2eo69h6ehswkb">
            No es solo contenido. Salís con cosas hechas.
          </h2>

          <ul className="mt-7 grid gap-3 sm:grid-cols-2 sm:gap-x-10" data-id="element-112" data-mp="2oj6n2azhv4ui">
            {takeaways.map(item => <li key={item} className="flex items-start gap-3" data-id="element-113" data-mp="2tdu98370zn5x">
                <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-sage text-white" data-id="element-114" data-mp="2y9j4vvfxcjwy">
                  <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-115" data-mp="32e8zlgyujsga" />
                </span>
                <span className="font-sans text-[15px] leading-snug text-petrol" data-id="element-116" data-mp="37c22o14us6cc">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}